<template>
  <div class="body-t">
    <van-sticky>
      <van-nav-bar left-arrow left-text="返回" title="企业展厅" @click-left="onClickLeft" />
    </van-sticky>
    <div v-if="!form" style="background: #FFFFFF;padding: 10px 0">
      <van-skeleton :row="25" avatar title />
    </div>
    <div v-else>
      <div class="user-box">
        <div class="main-top van-clearfix">
          <div>
            <van-image :src="form.logo" class="company-logo" fit="contain" lazy-load>
              <template v-slot:error class="logo-text">
                <span class="logo-text"> {{ form.CompanyName }}</span>
              </template>
            </van-image>
          </div>
          <div>
            <div class="company-title">
              {{ form.CompanyName ? form.CompanyName : '-' }}
            </div>
            <div class="cr-code">
              统一信用代码：{{ form.CreditCode ? form.CreditCode : '-' }}
            </div>
          </div>
        </div>
        <div>
          <dl class="golds-desc" v-if="form.count_ref">
            <dd @click="showTips()">
              <div>
                <img src="~@/assets/images/icon-fac.png" alt="" />
              </div>
              <div>
                <div class="title-d">工厂信息 <van-icon name="question-o" /></div>
                <div class="val-d">{{ form.count_ref.FactoryNumbers || '-' }}个</div>
              </div>
            </dd>
            <dd @click="showTips()">
              <div>
                <img src="~@/assets/images/icon-zl.png" alt="" />
              </div>
              <div>
                <div class="title-d">国家专利 <van-icon name="question-o" /></div>
                <div class="val-d">{{ form.count_ref.PatentNumbers || '-' }}个</div>
              </div>
            </dd>
            <dd @click="showTips()">
              <div>
                <img src="~@/assets/images/icon-lv.png" alt="" />
              </div>
              <div>
                <div class="title-d">绿色认证 <van-icon name="question-o" /></div>
                <div class="val-d">{{ form.count_ref.CGPNumbers || '-' }}个</div>
              </div>
            </dd>
          </dl>
        </div>
        <div class="top-tool ">
          <collection v-if="form.id" :company_id="form.id" class="add-box-res"></collection>
        </div>

      </div>
      <div v-if="medal_configs.is_show" class="pd-10">
        <div class="show-tit-gold">
          {{ medal_configs.title }}
        </div>
        <div>
          <dl class="cre-record">
            <dd v-for="(item, index) in form.medal" :key="item.id" @click="shareImg(index)">
              <div class="cr-top">
                {{ item.show_sort }}
              </div>
              <div class="cr-right">
                <div>
                  <span class="company-type">
                    {{ item.title }}
                  </span>
                </div>
                <div class="ct-tool">
                  <div class="ct-val">
                    {{ item.Interpretive_prefix }}：<span>{{
        item.unit_val
      }}{{ item.Interpretive_unit }}</span>
                  </div>
                  <div class="get-share">
                    获奖海报 <van-icon name="arrow" />
                  </div>
                </div>

              </div>
            </dd>
          </dl>
        </div>
        <div style="font-size: 12px;color: #C0C4CC;text-align: center;margin-top: 10px;">
          {{ medal_configs.tips }}
        </div>
        <van-popup v-model="popup.gold" closeable position="bottom" round
          style="width: 100%;height:580px;padding:0 10px;box-sizing: border-box">
          <div
            style="letter-spacing: 1px;font-size: 14px;text-align: center;font-weight: bold;color: #333333;margin-top: 15px">
            <van-icon name="bullhorn-o" />
            荣获以下奖项
          </div>
          <van-swipe ref="swipe" :loop="false" class="my-swipe" indicator-color="white" style="margin-top: 20px"
            @change="onChange">
            <van-swipe-item v-for="(item, index) in form.medal" :key="index">
              <div style="text-align: center;">
                <van-image :src="item.poster" class="share-img" fit="contain" lazy-load>
                  <template v-slot:loading>
                    <van-loading size="20" type="spinner" />
                    加载中
                  </template>
                  <template v-slot:error>加载失败</template>
                </van-image>
              </div>
              <div class="type-title-c">
                获奖行业：{{ item.title }}
              </div>
            </van-swipe-item>
            <template #indicator>
              <div v-if="form" class="custom-indicator">
                <van-icon name="medal-o" />
                {{ current + 1 }}/{{ form.medal.length }}
              </div>
            </template>
          </van-swipe>
          <div class="tips-share">
            <van-icon name="info-o" />
            左右滑动可切换海报，长按海报，可分享至朋友。
          </div>
        </van-popup>
      </div>

      <div class="pd-10">
        <div class="bt-item" v-if="form.CreditCode">
          <div class="show-tit">
            企业信息
          </div>
          <div>
            <van-form class="company-details-form" disabled label-align="right" readonly>
              <van-field v-model="form.CreditCode" :border="false" label="统一信用代码" placeholder="-" />
              <van-field v-model="form.RegNumber" :border="false" label="注册号" placeholder="-" />
              <van-field v-model="form.RegCompanyType" :border="false" label="企业类型" placeholder="-" />
              <van-field v-model="form.LegalPeople" :border="false" label="法人代表" placeholder="-" />
              <van-field v-model="form.RegCapital" :border="false" label="注册资本" placeholder="-" />
              <van-field v-model="form.RegAuthority" :border="false" label="登记机关" placeholder="-" />
              <van-field v-model="form.StructureCode" :border="false" label="组织机构代码" placeholder="-" />
              <van-field v-model="form.OperatingState" :border="false" label="经营状态" placeholder="-" />
              <van-field v-model="form.establish_date" :border="false" label="成立日期" placeholder="-" />
              <!-- <van-field v-model="form.business_term" :border="false" label="营业期限" placeholder="-" /> -->
              <van-field v-model="form.licens_date" :border="false" label="发照日期" placeholder="-" />
              <van-field v-model="form.ManagementScope" :autosize="{ minHeight: 100, maxHeight: 150 }" :border="false"
                label="经营范围" placeholder="-" type="textarea" />
            </van-form>
          </div>
        </div>

        <div class="bt-item" v-if="form.CompanyProfile.length > 1">
          <div class="show-tit">
            企业简介
          </div>
          <div :class="popup.open ? 'open' : 'van-multi-ellipsis--l3'" class="company-desc "
            v-html="form.CompanyProfile">
          </div>
          <div v-show="form.CompanyProfile.length < 1" class="no-data-tps">暂无企业简介</div>
          <div class="load-es-box">
            <span class="open-show-btn" @click="popup.open = !popup.open">
              <van-icon :name="popup.open ? 'arrow-up' : 'arrow-down'" />
              {{ popup.open ? '折叠' : '展开' }}
            </span>
          </div>
        </div>

        <div class="bt-item">
          <div class="show-tit">
            联系方式
          </div>
          <div>
            <van-form class="company-details-form call-form" disabled label-width="2rem" readonly>
              <van-field v-model="form.Tel" :border="false" label="电话" left-icon="phone-o" placeholder="-" />
              <van-field v-model="form.CompanyUrl" :border="false" label="官网" left-icon="desktop-o" placeholder="-" />
              <van-field v-model="form.Address" :border="false" label="地址" left-icon="location-o" placeholder="-"
                type="textarea" />
            </van-form>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<style scoped>
.pd-10 {
  padding: 10px;
}

.user-box {
  min-height: 170px;

  background: linear-gradient(1deg, #FFEDDF 0%, #FFEDDF 2%, #FFF4EA 100%);
  background-size: cover;
  padding: 25px 10px;
  box-sizing: border-box;
  /* box-shadow: 0px 2px 25px -5px #646566; */
  position: relative;
}

.user-box::after {
  content: '';
  position: absolute;
  background: url('~@/assets/images/arrow_right.png') no-repeat;
  background-size: contain;
  right: 10px;
  top: 10px;
  width: 140px;
  height: 170px;
}


.body-t {
  background: #f9f9f9;
  padding-bottom: 60px;
  min-height: calc(100vh);
}

.main-top {
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(194, 150, 94, .2)
}

.main-top>div {
  float: left;
  box-sizing: border-box;
}

.main-top>div:nth-child(1) {
  width: 120px;
  margin-right: 10px;
}

.main-top>div:nth-child(2) {
  width: calc(100% - 130px);
  display: grid;
  height: 65px;
  align-items: center;
}

.company-logo {
  width: 100%;
  height: 65px;
  display: block;
  background: white;
  object-fit: contain;
  border-radius: 3px;
  box-sizing: border-box;
  padding: 5px;
}

.company-title {
  color: #85461A;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 2px;
}

.cr-code {
  font-size: 12px;
  color: #A47B66;
}



.show-tit {
  font-size: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e2e2e2;
  font-weight: bold;
  letter-spacing: .5px;
}

.show-tit::before {
  content: "|";
  color: #F62A3A;
  vertical-align: top;
  font-weight: bold;
}


.tool-show /deep/ .van-grid-item__content {
  background: transparent;
}

.tool-show /deep/ .van-icon {
  color: #e8b279;
}

.bt-item {
  background: #FFFFFF;
  padding: 10px;
  margin-bottom: 20px;
  border-radius: 3px;
}

.company-details-form {
  margin-top: 10px;
}

.company-details-form /deep/ .van-cell {
  padding: 2px 0;
}

.call-form /deep/ .van-cell {
  padding: 5px 0;
}

.call-form /deep/ .van-field__left-icon .van-icon {
  color: rgba(255, 165, 0, 0.6);
  font-size: 12px;
}

.call-form /deep/ .van-field__label {
  margin-right: 5px;
}

.call-form /deep/ textarea {
  line-height: 1.2rem;
  margin-top: 2px;
}

.company-details-form /deep/ .van-cell__title {
  font-size: 12px;
  color: rgba(136, 136, 136, 1);
}

.company-details-form /deep/ input,
.company-details-form /deep/ textarea {
  font-size: 12px;
  color: rgba(51, 51, 51, 1);
  -webkit-text-fill-color: rgba(51, 51, 51, 1);
}

.company-desc {
  margin-top: 10px;
  font-size: 12px;
  color: rgba(51, 51, 51, 1);
  max-height: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  letter-spacing: .5px;
  line-height: 1.1rem;
}

.open-show-btn {
  width: 119px;
  height: 32px;
  line-height: 32px;
  background: linear-gradient(90deg, #FD8F75 0%, #F5625C 100%);
  border-radius: 18px;
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  color: #fde2e2;
  letter-spacing: 1px;
  display: block;
  margin: 10px auto;
}

.company-desc.open {
  max-height: 19999px;
}

.top-tool {
  margin-top: 10px;
}

.add-box-res /deep/ .van-button {
  border-radius: 3px;
  width: 100%;
  background: linear-gradient(180deg, #FD5F63 0%, #FC4A44 100%);
  height: 40px;
  color: #FFFFFF;
  letter-spacing: 2px;
}

.add-box-res /deep/ .van-button span,
.add-box-res /deep/ .van-button span:hover,
.add-box-res /deep/ .van-button span:focus {
  color: #FFFFFF;
}

.no-data-tps {
  margin: 15px auto;
  font-size: 12px;
  text-align: center;
  color: #646566;
}

.gold-list {
  margin-top: 15px;
}

.gold-list>li {
  margin-bottom: 10px;
  border-bottom: 1px dashed #e2e2e2;
  padding-bottom: 10px;
}

.gold-list>li:last-child {
  margin-bottom: 0;
  border: none;
}

.gold-list .left-ot {
  letter-spacing: 1.5px;
  font-size: 13px;
  font-weight: bold;
  color: #666666;
}

.gold-list .left-ot .van-icon {
  color: #F5625C;
  font-size: 14px;
}

.gold-list .right-ot {
  float: right;
  font-size: 12px;
  color: #F5625C;
}

.my-swipe /deep/ .custom-indicator {
  position: absolute;
  letter-spacing: 1px;
  border-radius: 3px;
  left: calc((100% - 60px) / 2);
  top: 10px;
  width: 60px;
  padding: 3px 0;
  text-align: center;
  color: #EB0035;
  font-size: 12px;
  background: rgba(255, 255, 255, .7);
}

.share-img {
  max-width: 310px;
  height: 460px;
  box-sizing: border-box;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
  background: #f7f8fa;
  position: relative;
}


.type-title-c {
  font-size: 12px;
  text-align: center;
  color: #7c161b;
  letter-spacing: 1px;
  margin-top: 3px;
  text-indent: .5rem;
}

.my-swipe /deep/ .van-swipe-item {
  box-sizing: border-box;
}

.my-swipe /deep/ .van-swipe-item:last-child {
  padding-right: 0;
}

.tips-share {
  font-size: 12px;
  color: #F35541;
  margin-top: 10px;
  text-align: center;
}

.count-top-bar {
  margin-top: 10px;
}

.sort-top {
  font-size: 16px;
  font-weight: bold;
  color: #FFFFFF;
  background: #E8B279;
  margin-left: 1.25rem;
  height: 25px;
  line-height: 25px;
  padding: 0 5px;
  display: inline-block;
  letter-spacing: .5px;
  text-align: center;
}

.sort-val {
  height: 25px;
  line-height: 25px;
  padding: 0 5px;
  font-size: 12px;
  color: #E8B279;
  display: inline-block;
  border: 1px solid;
  box-sizing: border-box;
}

.bt-item-medal {
  background: #FFFFFF;
  padding: 10px;
  border-radius: 3px;
}

.share-btn-box {
  text-align: center;
  margin-top: 25px;
}

.share-btn {
  background: #F35541;
  padding: 10px 25px;
  border-radius: 50px;
  font-size: 12px;
  display: inline-block;
  color: #FFFFFF;
}

.golds-desc {
  display: flex;
  padding: 0;
  position: relative;
  z-index: 1;
}

.golds-desc>dd {
  background: linear-gradient(91deg, #FFE3CD 0%, #FFDBB5 98%);
  min-height: 30px;
  width: 100%;
  margin-left: 0;
  margin-right: 10px;
  border-radius: 2px;
}

.golds-desc>dd:nth-child(3n) {
  margin-right: 0;
}

.golds-desc>dd {
  display: flex;
  font-size: 12px;
  padding: 10px;
  border-bottom: 2px solid #F5625C;
}

.golds-desc>dd>div:first-child {
  width: 30px;
  display: flex;
  align-items: center;
}

.golds-desc>dd>div:last-child {
  width: calc(100% - 30px);
  padding-left: 5px;
}

.golds-desc .title-d {
  font-size: 12px;
  color: #886254;
}

.golds-desc .val-d {
  font-size: 12px;
  font-family: D-DIN-DIN-Bold, D-DIN-DIN;
  font-weight: bold;
  color: #A05F1F;
  margin-top: 5px;
  letter-spacing: .5px;
}

.show-tit-gold {
  font-size: 16px;
  position: relative;
  margin-top: 10px;
  font-weight: bold;
  z-index: 1;
}

.show-tit-gold::after {
  position: absolute;
  content: '';
  width: 70px;
  height: 5px;
  display: inline-block;
  background: linear-gradient(90deg, #F04035 0%, rgba(240, 64, 3, 0.2) 80%, #FEF4EB 100%);
  bottom: 4px;
  left: 0px;
  z-index: -1;
}

.cre-record {
  margin: 0;
  padding: 0;
  margin-top: 10px;
}

.cre-record>dd {
  margin: 0;
  padding: 0;
  background-color: #ffffff;
  border-radius: 3px;
  min-height: 20px;
  display: flex;
  position: relative;
  margin-bottom: 10px;
}

.cre-record>dd .cr-top {
  width: 60px;
  min-height: 60px;
  background: url("~@/assets/images/icon-top.png") no-repeat;
  background-size: 35px;
  background-position: top;
  text-align: center;
  line-height: 58px;
  color: #fff;
}

.cre-record>dd .cr-right {
  padding: 15px 5px;
  font-size: 12px;
  position: relative;
  width: 100%;

}

.cre-record>dd::after {
  position: absolute;
  content: "";
  background: url("~@/assets/images/icon-vector.png") no-repeat;
  background-size: contain;
  width: 25px;
  height: 25px;
  right: 0;
  top: 0;
}

.cre-record>dd .cr-right .company-type {
  letter-spacing: .5px;
  font-size: 13px;
  font-weight: bold;
  color: #666666;
  position: relative;
  z-index: 1;
}

.cre-record>dd .cr-right .ct-val {
  font-size: 12px;
  color: #999999;
  margin-top: 15px;
}

.ct-tool {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.logo-text {
  text-align: center;
  background: #ffffff;
  color: #333333;
  font-weight: bold;
  letter-spacing: 1px;
  padding: 5px;
  height: 65px;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  align-items: center;
  border-radius: 2px;
  font-size: 12px;
  overflow: hidden;
  width: 100%;
}

.ct-val span {
  color: #F35541;
}

.get-share {
  font-size: 12px;
  background: #F35541;
  padding: 5px;
  padding-left: 10px;
  border-radius: 50px;
  color: #ffffff;
}
</style>
<script>

import Collection from "../components/Collection";

export default {
  name: "Hall",
  components: { Collection },
  metaInfo() {
    return {
      title: (this.form ? this.form.CompanyName : '') + '展厅-优采云大数据服务平台',
      htmlAttrs: {
        lang: 'zh-CN',
        keyword: '优采云，大数据，云服务，报告',
        amp: true
      }
    }

  },
  data() {
    return {
      load: {
        logout: false
      },
      current: 0,
      popup: {
        open: false,
        gold: false
      },
      form: null,
      medal_configs: {
        is_show: false,
        title: '-',
        tips: "-"
      }
    }
  },
  mounted() {
    var id = this.$route.query.id ? this.$route.query.id : null
    if (!id) {
      this.$notify({ message: "查询参数错误，已返回", type: "warning" })
      this.$router.go(-1)
      return
    }
    const toast = this.$toast.loading({
      message: '加载中...',
      forbidClick: true,
    });

    this.$axios.post(this.$apiconfg.hall, {
      id: id
    }).then(({ data }) => {
      toast.clear()
      if (!data || !data.IsUsed === '1') {
        return
      }
      this.form = data.data
      this.medal_configs = data.data.medal_configs
      var share_company = data.data
      //微信分享
      var wx = require('weixin-js-sdk');
      this.$axios.post(this.$apiconfg.wechat, {
        url: location.href
      }).then(({ data }) => {
        if (data.code === 1) {
          const config = data.data
          wx.config(config)
          wx.ready(function () {
            console.log('微信分享Ready-ok')

            const share_data = {
              title: (share_company ? share_company.CompanyName : '') + '企业获评2024房建供应链企业首选供应商服务商品牌', // 分享标题
              desc: "测评是房建领域工程采购招投标及战略合作的重要参考。聚焦6大领域，7大品类，超过150个子项",// 分享描述
              imgUrl: share_company.logo ? share_company.logo : 'https://api-report.dichan.com/static/images/youcai-wechat-share.png', // 分享图标
              link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              success: function () {
                // 设置成功
                console.log('自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容-ok')
              }
            }
            //自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
            wx.updateAppMessageShareData(share_data)
            //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
            wx.updateTimelineShareData(share_data)

          });
          wx.error(function (res) {
            console.log('微信分享Ready-fail')
            console.error(res)
          });
        }
      })

    })

  },
  methods: {
    onClickLeft() {
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.push('/')
      }
    },
    shareImg(index) {
      this.popup.gold = true
      this.$refs.swipe.swipeTo(index)

    },
    onChange(index) {
      this.current = index;
    },
    showTips() {
      this.$dialog.alert({
        message: '该数据为申报行业填写时，各行业数量累加，仅供参考',
      });
    }
  }
}
</script>
